import {NgModule} from '@angular/core';
import {LayoutModule} from '../../layout-components/layout.module';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {BankFieldsComponent} from './bank-fields.component';
import {BankFieldsService} from './bank-fields.service';


@NgModule({
    imports: [
        FormFieldModule,
        ReactiveFormsModule,
        CommonModule,
        LayoutModule,
    ],
    exports: [
        BankFieldsComponent
    ],
    declarations: [
        BankFieldsComponent
    ],
    providers: [
        {provide: BankFieldsService, useClass: BankFieldsService},
    ],
})
export class BankFieldsModule {
}
